import { Link, useLocation, useNavigate } from 'react-router-dom';
import {      Webhook, Compass, Globe, UploadCloud, Clock, MessageSquare, Database, Home, Users, BarChart2, PlusCircle, Settings, FileText, Share2, List, LayoutGrid, LogOut, ChevronDown, ChevronRight, Building, Bell, ScrollText, Wallet , Plug, Image, CheckSquare, TrendingUp, Layers, PenTool, ShieldAlert, BookOpen, Activity , Map , Send , Shield , UserCheck, Briefcase, Server , Target } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import React, { useState } from 'react';
import logo from '../assets/logo_new.png';
import logoWhite from '../assets/logo_new_white.png';
import { API_URL as CONFIG_API_URL } from '../config';
const API_URL = CONFIG_API_URL || 'http://8.141.122.155:3002/api';

import { Search } from 'lucide-react';

export const primeMenuItems = [
  {
    label: 'PRIME 战略引擎',
    icon: Activity,
    permission: 'menu:prime_engine',
    children: [
      { href: '/prime/projects', icon: List, label: '战略项目矩阵', permission: 'page:prime_projects' },
      { href: '/prime/wizard', icon: Settings, label: '战略部署向导', permission: 'page:prime_wizard' },
      { href: '/prime/matrix', icon: Map, label: '全息意图矩阵', permission: 'page:prime_matrix' },
      { href: '/prime/galaxy', icon: Compass, label: '3D意图星图', permission: 'page:prime_matrix' },
      { href: '/prime/dispatch', icon: Send, label: '智算探针集群', permission: 'page:prime_dispatch' },
      { href: '/prime/radar', icon: Activity, label: '全景心智罗盘', permission: 'page:prime_radar' },
      { href: '/prime/injection', icon: Target, label: '靶向占位引擎', permission: 'page:prime_injection' },
    ]
  },
  {
    label: 'RAG 品牌语料库',
    icon: Database,
    permission: 'menu:prime_corpus',
    children: [
      { href: '/corpus/collection', icon: BookOpen, label: '官方语料库', permission: 'page:corpus_collection' },
      { href: '/corpus/crawl', icon: Globe, label: '生态溯源回流', permission: 'page:corpus_crawl' },
      { href: '/corpus/repository', icon: Layers, label: '结构化语料池', permission: 'page:corpus_repository' },
      { href: '/corpus/insights', icon: TrendingUp, label: '智能推荐洞察', permission: 'page:corpus_insights' },
    ]
  },
  { 
    label: '系统设置', 
    icon: Settings, 
    permission: 'menu:system',
    children: [
      { href: '/system/users', icon: Users, label: '用户管理', permission: 'page:users' },
      { href: '/system/groups', icon: Users, label: '用户组管理', permission: 'page:user_groups' },
      { href: '/system/roles', icon: CheckSquare, label: '角色与权限', permission: 'page:user_manage' },
      { href: '/system/cost', icon: Wallet, label: '系统扣费配置', permission: 'page:cost' },
      { href: '/system/api-config', icon: Plug, label: 'API 接口配置', permission: 'page:api_config' },
      { href: '/system/announcements', icon: Bell, label: '通知公告', permission: 'page:announcements' },
      { href: '/system/logs', icon: ScrollText, label: '系统日志', permission: 'page:logs' },
      { href: '/system/ops-dashboard', icon: Activity, label: '调度监控大盘', permission: 'page:ops_dashboard' },
      { href: '/system/expansion', icon: Target, label: '拓词调度舱', permission: 'page:ops_dashboard' },
      { href: '/settings/data-push', icon: Webhook, label: '第三方数据分发', permission: 'page:api_config' },
    ]
  }
];
export const geoMenuItems = [

  { href: '/', icon: LayoutGrid, label: '监控总览', permission: 'page:dashboard' },
  { href: '/engine-monitor', icon: BarChart2, label: '引擎表现大盘', permission: 'page:engine_monitor' },
  { href: '/brand-insights', icon: TrendingUp, label: '品牌数据洞察', permission: 'page:brand_insights' },
    { 
    label: '电商转化归因',
    icon: Wallet,
    permission: 'menu:commerce',
    children: [
      { href: '/commerce/matrix', icon: LayoutGrid, label: '商品卡位矩阵', permission: 'page:commerce_matrix' },
      { href: '/commerce/analytics', icon: TrendingUp, label: '流量归因分析', permission: 'page:commerce_analytics' },
      { href: '/commerce/data-hub', icon: Database, label: '罗盘数据接入', permission: 'page:commerce_data_hub' }
    ]
  },
  { href: '/mention-records', icon: MessageSquare, label: '溯源明细记录', permission: 'page:mention_records' },
  { 
    label: '内容与语料资产', 
    icon: Database, 
    permission: 'menu:corpus', 
    children: [ 
      { href: '/corpus/collection', icon: UploadCloud, label: '品牌官方语料', permission: 'page:corpus_collection' }, 
      { href: '/corpus/crawl', icon: Globe, label: '生态溯源回流', permission: 'page:corpus_crawl' },
      { href: '/corpus/repository', icon: Layers, label: '结构化语料池', permission: 'page:corpus_repository' }, 
      { href: '/corpus/insights', icon: TrendingUp, label: '智能推荐洞察', permission: 'page:corpus_insights' },
      { href: '/corpus/assets', icon: Image, label: '内容资产矩阵', permission: 'page:corpus_collection' }
    ] 
  },
  { href: '/reports', icon: FileText, label: '对比分析报告', permission: 'page:reports' },
    { 
    label: '任务调度中心',
    icon: List,
    permission: 'menu:tasks',
    children: [
      { href: '/subscriptions', icon: Clock, label: '订阅调度大盘', permission: 'page:tasks' },
      { href: '/tasks', icon: List, label: '定时抓取任务', permission: 'page:tasks' },
      { href: '/results', icon: Database, label: '抓取结果明细', permission: 'page:results' },
    ]
  },
  { 
    label: '品牌业务配置', 
    icon: Layers, 
    permission: 'menu:geo_settings',
    children: [
      { href: '/settings/brands', icon: Building, label: '品牌与竞品配置', permission: 'page:geo_brands' },
      { href: '/settings/sensitive', icon: ShieldAlert, label: '品牌敏感词库', permission: 'page:geo_sensitive' },
      { href: '/settings/source-dict', icon: BookOpen, label: '信源字典', permission: 'page:geo_settings' },
      { href: '/settings/engines', icon: Settings, label: '引擎与抓取配置', permission: 'page:geo_engines' },

    ]
  },
  { 
    label: '系统设置', 
    icon: Settings, 
    permission: 'menu:system',
    children: [
      { href: '/system/users', icon: Users, label: '用户管理', permission: 'page:users' },
      { href: '/system/groups', icon: Users, label: '用户组管理', permission: 'page:user_groups' },
      { href: '/system/roles', icon: CheckSquare, label: '角色与权限', permission: 'page:user_manage' },
      { href: '/system/cost', icon: Wallet, label: '系统扣费配置', permission: 'page:cost' },
      { href: '/system/api-config', icon: Plug, label: 'API 接口配置', permission: 'page:api_config' },
      { href: '/system/announcements', icon: Bell, label: '通知公告', permission: 'page:announcements' },
      { href: '/system/logs', icon: ScrollText, label: '系统日志', permission: 'page:logs' },
      { href: '/system/ops-dashboard', icon: Activity, label: '调度监控大盘', permission: 'page:ops_dashboard' },
      { href: '/system/expansion', icon: Target, label: '拓词调度舱', permission: 'page:ops_dashboard' },
      { href: '/settings/data-push', icon: Webhook, label: '第三方数据分发', permission: 'page:api_config' },
      { href: '/settings/industry-library', icon: Database, label: '行业预置词库', permission: 'page:geo_industry_lib' },
    ]
  },

];
export const seoMenuItems = [
  { icon: Home, label: '监控总览', href: '/seo/overview' },
  { icon: BarChart2, label: '引擎表现大盘', href: '/seo/dashboard' },
  { icon: TrendingUp, label: '品牌数据洞察', href: '/seo/insights' },
  { icon: Share2, label: '媒体/达人占位', href: '/seo/media' },
  { icon: Compass, label: '内容生态解析', href: '/seo/ecology' },
  { icon: Layers, label: '对比分析报告', href: '/seo/compare' },
  { 
    label: '抓取调度中心',
    icon: List,
    children: [
      { href: '/seo/subscriptions', icon: Clock, label: '订阅调度大盘' },
      { href: '/seo/tasks', icon: List, label: '定时抓取任务' },
      { href: '/seo/results', icon: Database, label: '抓取结果明细' },
    ]
  },
  { 
    icon: Layers, 
    label: '品牌业务配置', 
    children: [
      { icon: Building, label: '品牌与竞品配置', href: '/seo/config' },
      
      { icon: Settings, label: '平台与抓取配置', href: '/seo/engines' }
    ]
  },
  { 
    label: '系统设置', 
    icon: Settings, 
    permission: 'menu:system',
    children: [
      { href: '/system/users', icon: Users, label: '用户管理', permission: 'page:users' },
      { href: '/system/groups', icon: Users, label: '用户组管理', permission: 'page:user_groups' },
      { href: '/system/roles', icon: CheckSquare, label: '角色与权限', permission: 'page:user_manage' },
      { href: '/system/cost', icon: Wallet, label: '系统扣费配置', permission: 'page:cost' },
      { href: '/system/api-config', icon: Plug, label: 'API 接口配置', permission: 'page:api_config' },
      { href: '/system/announcements', icon: Bell, label: '通知公告', permission: 'page:announcements' },
      { href: '/system/logs', icon: ScrollText, label: '系统日志', permission: 'page:logs' },
      { href: '/system/ops-dashboard', icon: Activity, label: '调度监控大盘', permission: 'page:ops_dashboard' },      { href: '/settings/industry-library', icon: Database, label: '行业预置词库', permission: 'page:geo_industry_lib' },

    ]
  }
];


export default function Sidebar() {
  const { pathname } = useLocation();
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [openSubmenus, setOpenSubmenus] = useState({'品牌业务配置': true, '系统设置': false, 'PRIME 战略引擎': true, 'RAG 品牌语料库': true});
  const [showAppSwitcher, setShowAppSwitcher] = useState(false);
  const [geoMode, setGeoMode] = useState(() => {
    return pathname.startsWith('/prime') ? 'prime' : 'score';
  });

  React.useEffect(() => {
    if (pathname.startsWith('/prime')) {
      setGeoMode('prime');
    } else if (['/dashboard', '/tasks', '/results', '/brand-projects', '/engine-configs'].some(p => pathname.startsWith(p))) {
      setGeoMode('score');
    }
  }, [pathname]);
  const [currentApp, setCurrentApp] = useState(() => {
    // If we're on a specific route, force the app
    if (pathname.startsWith('/seo')) { localStorage.setItem('currentApp', 'SEO 矩阵洞察系统'); return 'SEO 矩阵洞察系统'; }
    if (pathname.startsWith('/sem')) { localStorage.setItem('currentApp', 'SEM 竞价管理系统'); return 'SEM 竞价管理系统'; }
    if (pathname.startsWith('/feeds')) { localStorage.setItem('currentApp', 'Feeds 信息流系统'); return 'Feeds 信息流系统'; }
    
    // If we are on /system, preserve the last app, default to GEO
    const saved = localStorage.getItem('currentApp');
    if (saved) return saved;
    return 'GEO 全景监控系统';
  });
  
  React.useEffect(() => {
    const isGlobalPath = pathname.startsWith('/system') || pathname.startsWith('/guide') || pathname.startsWith('/settings/profile') || pathname.startsWith('/settings/data-push') || pathname.startsWith('/accounts');
    
    if (pathname.startsWith('/seo') && currentApp !== 'SEO 矩阵洞察系统') {
      setCurrentApp('SEO 矩阵洞察系统');
    } else if (pathname.startsWith('/sem') && currentApp !== 'SEM 竞价管理系统') {
      setCurrentApp('SEM 竞价管理系统');
    } else if (pathname.startsWith('/feeds') && currentApp !== 'Feeds 信息流系统') {
      setCurrentApp('Feeds 信息流系统');
    } else if (!pathname.startsWith('/seo') && !pathname.startsWith('/sem') && !pathname.startsWith('/feeds') && !isGlobalPath && currentApp !== 'GEO 全景监控系统') {
      setCurrentApp('GEO 全景监控系统');
    }
    localStorage.setItem('currentApp', currentApp);
  }, [pathname, currentApp]);
  
  
  const isAdmin = user?.role === 'ADMIN';
  const availableApps = [];
  if (isAdmin || user?.allowGeo !== false) availableApps.push('GEO 全景监控系统');
  if (isAdmin || user?.allowSeo === true) availableApps.push('SEO 矩阵洞察系统');
  if (isAdmin || user?.allowSem === true) availableApps.push('SEM 竞价管理系统');
  if (isAdmin || user?.allowFeeds === true) availableApps.push('Feeds 信息流系统');
  const apps = availableApps;

  // Sync state if currentApp isn't allowed
  React.useEffect(() => {
    if (apps.length > 0 && !apps.includes(currentApp)) {
      setCurrentApp(apps[0]);
    }
  }, [user, currentApp, apps]);


  const toggleSubmenu = (label) => {
    setOpenSubmenus(prev => ({...prev, [label]: !prev[label]}));
  };

  // Guard against null user
  if (!user) {
    return (
      <aside className="w-64 bg-gray-900 text-gray-100 flex flex-col h-screen p-4 justify-center text-center">
        <p className="text-gray-500">加载中...</p>
      </aside>
    );
  }

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const userPermissions = user.permissions || [];
  const hasAccess = (permission) => {
    if (user.role === 'ADMIN') return true;
    if (userPermissions.includes('page:all')) return true;
    if (!permission) return true; // If no permission required, allow access
    
    // Legacy fallback
    if (!user.permissions && user.role === 'ADMIN') return true;
    
    // Let everyone see GEO Settings for now during development
    if (permission.startsWith('menu:geo_settings') || permission.startsWith('page:geo_') || permission.startsWith('menu:prime_') || permission.startsWith('page:prime_')) return true;
    
    if (!user.permissions && user.role === 'CUSTOMER') {
        const adminPages = ['menu:system', 'page:user_manage', 'page:api_config', 'page:cost', 'page:announcements', 'page:logs', 'page:user_groups', 'page:users', 'menu:commerce', 'page:commerce'];
        if (!adminPages.some(p => permission.startsWith(p))) return true;
    }
    
    return userPermissions.includes(permission);
  };

  // Filter items and their children based on permissions
  
  const getMenuItems = () => {
    if (currentApp === 'SEO 矩阵洞察系统') return seoMenuItems;
    if (currentApp === 'GEO 全景监控系统' && geoMode === 'prime') return primeMenuItems;
    return geoMenuItems;
  };
  const filteredItems = getMenuItems()
.map(item => {
    if (item.children) {
      const filteredChildren = item.children.filter(child => hasAccess(child.permission));
      // If no children are accessible, hide the parent group entirely
      if (filteredChildren.length === 0) return null;
      return { ...item, children: filteredChildren };
    }
    
    // For items without children, check permission directly
    if (!hasAccess(item.permission)) return null;
    return item;
  }).filter(Boolean);

  let roleDisplayName = user.role === 'ADMIN' ? '管理员' : '客户';
  if (user.roles && user.roles.length > 0) {
    roleDisplayName = user.roles.map(r => r.displayName).join(', ');
  }


  

  

  const getAppAccent = () => {
    if (currentApp === 'SEO 矩阵洞察系统') return 'text-emerald-300';
    if (currentApp === 'SEM 竞价管理系统') return 'text-amber-300';
    if (currentApp === 'Feeds 信息流系统') return 'text-rose-300';
    return 'text-blue-300'; // GEO
  };
  
  const getAppBgAccent = () => {
    if (currentApp === 'SEO 矩阵洞察系统') return 'border-emerald-400/30 shadow-[0_0_10px_rgba(52,211,153,0.2)]';
    if (currentApp === 'SEM 竞价管理系统') return 'border-amber-400/30 shadow-[0_0_10px_rgba(251,191,36,0.2)]';
    if (currentApp === 'Feeds 信息流系统') return 'border-rose-400/30 shadow-[0_0_10px_rgba(251,113,133,0.2)]';
    return 'border-blue-400/30 shadow-[0_0_10px_rgba(96,165,250,0.2)]';
  };

  return (
    <aside className="w-64 h-screen p-4 sticky top-0 transition-colors duration-500">
      <div className="h-full flex flex-col bg-gradient-to-b from-[#625fa5] to-[#2996cf] dark:from-slate-900 dark:to-slate-800 shadow-xl rounded-3xl overflow-hidden text-white transition-all duration-500">
        {/* Logo Area */}
        <div className="relative z-50 p-5 flex flex-col justify-center items-center border-b border-white/10 bg-white/5">
          <div className="bg-white/90 dark:bg-transparent hover:bg-white dark:hover:bg-transparent transition-all backdrop-blur-md dark:backdrop-blur-none rounded-xl px-4 py-2 w-full flex justify-center mb-3">
            <img src={logo} alt="Sapient Rank Logo" className="h-8 w-auto object-contain dark:hidden" />
            <img src={logoWhite} alt="Sapient Rank Logo" className="h-8 w-auto object-contain hidden dark:block" />
          </div>
          
          <div className="relative w-full mt-1">
            <button 
              onClick={() => setShowAppSwitcher(!showAppSwitcher)}
              className={`w-full flex items-center justify-between bg-black/20 hover:bg-black/30 dark:bg-white/10 dark:hover:bg-white/20 transition-all rounded-lg px-3 py-2 text-sm font-bold border hover:border-white/20 ${getAppBgAccent()} ${getAppAccent()}`}
            >
              <span className="tracking-widest uppercase truncate">{currentApp}</span>
              <ChevronDown size={14} className={`flex-shrink-0 ml-1 opacity-70 transition-transform duration-200 ${showAppSwitcher ? 'rotate-180' : ''}`} />
            </button>
            
            {showAppSwitcher && (
              <>
                <div 
                  className="fixed inset-0 z-40" 
                  onClick={() => setShowAppSwitcher(false)}
                ></div>
                <div className="absolute top-full left-0 right-0 mt-2 bg-white dark:bg-slate-800 rounded-xl shadow-2xl overflow-hidden z-50 border border-gray-100 dark:border-slate-700 py-1">
                  {apps.map((appName) => (
                    <button
                      key={appName}
                      onClick={() => {
                        setCurrentApp(appName);
                        setShowAppSwitcher(false);
                        if (appName === 'SEO 矩阵洞察系统') {
                          navigate('/seo/overview');
                        } else if (appName === 'SEM 竞价管理系统') {
                          navigate('/sem/overview');
                        } else if (appName === 'Feeds 信息流系统') {
                          navigate('/feeds/overview');
                        } else {
                          navigate('/');
                        }
                      }}
                      className={`w-full text-left px-4 py-2.5 text-sm font-medium transition-colors ${
                        currentApp === appName 
                          ? 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400' 
                          : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-slate-700/50'
                      }`}
                    >
                      {appName}
                    </button>
                  ))}
                </div>
              </>
            )}
          </div>


          {/* Prime/Score Switcher - Only show for GEO App */}
          {currentApp === 'GEO 全景监控系统' && (
            <div className="w-full mt-4">
              <div className="flex items-center p-1 bg-black/20 dark:bg-slate-900/50 rounded-lg shadow-inner relative overflow-hidden backdrop-blur-sm border border-white/5">
                <div 
                  className={`absolute top-1 bottom-1 w-[calc(50%-4px)] bg-gradient-to-r from-blue-500 to-cyan-500 rounded-md shadow transition-all duration-300 ease-out ${geoMode === 'prime' ? 'left-1' : 'left-1/2'}`}
                ></div>
                
                <button
                  onClick={() => setGeoMode('prime')}
                  className={`relative flex-1 py-1.5 text-[11px] font-bold tracking-widest flex items-center justify-center gap-1.5 whitespace-nowrap z-10 transition-colors duration-200 ${geoMode === 'prime' ? 'text-white' : 'text-white/60 hover:text-white/90'}`}
                >
                  <Activity className={`w-3.5 h-3.5 ${geoMode === 'prime' ? 'text-white' : 'text-white/50'}`} />
                  思 PRIME
                </button>
                
                <button
                  onClick={() => setGeoMode('score')}
                  className={`relative flex-1 py-1.5 text-[11px] font-bold tracking-widest flex items-center justify-center gap-1.5 whitespace-nowrap z-10 transition-colors duration-200 ${geoMode === 'score' ? 'text-white' : 'text-white/60 hover:text-white/90'}`}
                >
                  <Target className={`w-3.5 h-3.5 ${geoMode === 'score' ? 'text-white' : 'text-white/50'}`} />
                  序 SCORE
                </button>
              </div>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto custom-scrollbar">
          {filteredItems.map(item => {
             const Icon = item.icon;
             
             if (item.children) {
               const isOpen = openSubmenus[item.label];
               const isActive = item.children.some(child => pathname === child.href);
               
               return (
                 <div key={item.label}>
                   <button
                    onClick={() => toggleSubmenu(item.label)}
                    className={`flex items-center w-full px-4 py-3 rounded-xl transition-all duration-200 group text-left justify-between ${
                      isActive ? 'bg-white/20 text-white' : 'text-white/70 hover:bg-white/10 hover:text-white'
                    }`}
                   >
                     <div className="flex items-center">
                       <Icon className={`w-5 h-5 mr-3 ${isActive ? 'text-white' : 'text-white/50 group-hover:text-white transition-colors'}`} />
                       <span className="font-medium text-sm">{item.label}</span>
                     </div>
                     {isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                   </button>
                   
                   {isOpen && (
                     <div className="ml-4 mt-1 space-y-1 border-l border-white/20 pl-2">
                       {item.children.map(child => {
                         const ChildIcon = child.icon;
                         return (
                           <Link
                             key={child.href}
                             to={child.href}
                             className={`flex items-center px-4 py-2 rounded-lg text-sm transition-all duration-200 ${
                               pathname === child.href 
                                 ? 'bg-white/20 text-white font-semibold' 
                                 : 'text-white/70 hover:bg-white/10 hover:text-white'
                             }`}
                           >
                             {ChildIcon && <ChildIcon className="w-4 h-4 mr-2 opacity-70" />}
                             <span>{child.label}</span>
                           </Link>
                         );
                       })}
                     </div>
                   )}
                 </div>
               );
             }

             return (
              <Link
                key={item.href}
                to={item.href}
                className={`flex items-center px-4 py-3 rounded-xl transition-all duration-200 group text-left ${
                  pathname === item.href 
                    ? 'bg-white/20 text-white font-semibold shadow-inner' 
                    : 'text-white/70 hover:bg-white/10 hover:text-white'
                }`}
              >
                <Icon className={`w-5 h-5 mr-3 ${pathname === item.href ? 'text-white' : 'text-white/50 group-hover:text-white transition-colors'}`} />
                <span className={`text-sm ${pathname === item.href ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
              </Link>
             );
          })}
        </nav>

        {/* User Profile */}
        <div className="p-4 mt-auto">
          <div className="flex items-center p-3 bg-white/10 rounded-2xl border border-white/10 hover:bg-white/20 transition-colors cursor-pointer group relative">
            {user?.avatar ? (
              <img src={user.avatar.startsWith('http') ? user.avatar : API_URL.replace('/api', '') + user.avatar} alt="Avatar" className="w-10 h-10 rounded-full object-cover shadow-sm flex-shrink-0 bg-white" />
            ) : (
              <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-sidebar-from font-bold shadow-sm flex-shrink-0">
                {(user?.name || 'U')[0]}
              </div>
            )}
            <div className="ml-3 overflow-hidden flex-1">
              <p className="text-sm font-bold text-white truncate">{user.name || 'User'}</p>
              <p className="text-xs text-white/70 truncate" title={roleDisplayName}>{roleDisplayName}</p>
            </div>
            <button 
              onClick={handleLogout}
              className="absolute right-2 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 bg-red-500 p-2 rounded-full text-white transition-opacity shadow-lg"
              title="退出登录"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </div>
    </aside>
  );
}